/**
 * Created by zhangrp on 2018/8/28.
 */
import api from './index';

let exports = {};

exports.isMerchtAuditBpConfAvailable = function (data/*bizTypeCode：审批业务类型，必传*/, callback) {   // 获取是否有可用的审批业务流程配置
    api.post('/oa/audit/bp/conf/available/get')
    .data(data)
    .done(callback)
    .go();
};

exports.getMerchtAuditBpRecs = function (data, callback) {   // 获取商户审批业务流程记录列表
    api.post('/oa/audit/mercht/audit/bp/rec/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.getMerchtAuditBpRecsByBizVoucherNo = function (params, callback) {   // 获取商户审批业务流程记录列表
    api.get('/oa/audit/mercht/audit/bp/rec/list/get/by/bizVoucherNo')
    .params(params)
    .done(callback)
    .go();
};
exports.getBpStartPageUrl = function (params, callback) {   // 获取商户审批业务流程记录列表
    api.get('/oa/audit/bp/start/page/url/get')
    .params(params)
    .done(callback)
    .go();
};

exports.getOuterOrgList = function (params, callback) {   // 获取外部OA审核用的机构列表
    api.get('/oa/audit/outer/org/list/get')
    .params(params)
    .done(callback)
    .go();
};

exports.getOuterOrgStaffList = function (params, callback) {   // 获取外部OA审核用的机构下人员列表
    api.get('/oa/audit/outer/org/staff/list/get')
    .params(params)
    .done(callback)
    .go();
};

exports.getOuterOrgLikeStaffList = function (params, callback) {   // 模糊查询-获取外部OA审核用的机构下人员列表
    api.get('/oa/audit/outer/org/like/staff/list/get')
    .params(params)
    .done(callback)
    .go();
};

exports.getMerchtAuditBpInstByFilter = function (data, callback) {  // 获取流程实例
    api.post('/oa/audit/mercht/audit/bp/inst/get')
    .data(data)
    .done(callback)
    .go();
};

exports.getMerchtAuditBpConfInfo = function (data, callback) {  // 获取流程配置，已就绪 && 根据优先级 sqlNo 去第一个。
    api.post('/oa/audit/bp/conf/info/get')
    .data(data)
    .done(callback)
    .go();
};

exports.getMerchtAuditBpConfList = function (data, callback) {  // 获取当前业务可用的审批流程
    api.post('/oa/audit/bp/conf/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.getMerchtAuditBpNodeList = function (data, callback) {
    api.post('/oa/audit/bp/node/list/get')
    .data(data)
    .done(callback)
    .go();
};
// 钉钉审批获取发起人（部门）信息
exports.getDingDingUserDetail = function (params, callback) {
    api.get('/oa/audit/dingding/user/info/get')
    .params(params)
    .done(callback)
    .go();
};

// 获取飞书发起人、部分信息
exports.getFeiShuUserDetail = function (params, callback) {
    api.get('/oa/audit/feiShu/user/info/get')
    .params(params)
    .done(callback)
    .go();
};

// 飞书：手动发起刷新审批记录
exports.saveBizVoucherRecForFeishuAudit = function (data, callback) {
    api.post('/oa/audit/feiShu/audit/rec/save/do')
    .data(data)
    .done(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/oaAudit.js
// module id = 49
// module chunks = 0